export default __webpack_public_path__ + "static/media/UHD_PRO_1.363455ad.png";